export const getScheduledOrderCredits = scheduledOrder => {
  const order = scheduledOrder?.order || scheduledOrder;
  const credits = Number(order?.credits);

  if (order?.credits !== null && order?.credits !== undefined && Number.isFinite(credits)) {
    return credits;
  }

  const price = Number(order?.price);

  return Number.isFinite(price) ? Math.round(price * 100) : 0;
};

export const formatCredits = credits =>
  (Number(credits || 0) / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
